import React from 'react';
import { cs } from '@bbkAdminUtils/css-utils';
import { getFlagFromCurrency } from '@bbkPricingPage/lib/currencies';
import { useCountryFlagFont } from '@bbkPricingPage/lib/currencies/use-country-flag-font';

export const CurrencyFlag = ({
  currencyCode,
  className,
}: {
  currencyCode: string;
  className?: string;
}) => {
  useCountryFlagFont();

  return (
    <span className={cs('tw-font-country-flags', className)}>
      {getFlagFromCurrency(currencyCode)}
    </span>
  );
};
